import { APP_BASE_HREF } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { Observable } from 'rxjs';

/**
 * Reads the catalogue each app's build copies from the repo-root `i18n/{pcp,tut}/` into
 * `/assets/i18n`. Which brand an app gets is decided by that asset glob, so this loader is
 * brand-agnostic.
 */
@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private readonly http = inject(HttpClient);
    private readonly baseHref = inject(APP_BASE_HREF);

    // Explicit return type: without it ng-packagr cannot name the inferred rxjs type
    // across the pnpm store and fails the library build with TS2742.
    getTranslation(lang: string): Observable<Translation> {
        return this.http.get<Translation>(`${this.baseHref}assets/i18n/${lang}.json`);
    }
}
